<template>
  <div>
    <div v-if="data_onshow" class="sp-full-page" @click="close()">
      <div class="bg-anim"></div>
      <div class="center-pic-box">
        <div class="center-pic">
          <picColored
            :img="data_onshow.image_url ||'https://lionnft.s3.ap-northeast-1.amazonaws.com/lions8/10010101.jpg' || '/static/img/lion_full.png'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import picColored from '@/views/_cp_base/pic_colored.vue'

export default {
  name: 'lionNewBornShow',
  components: {
    picColored,
  },
  props: [
  ],
  data() {
    return {
      
    }
  },
  computed: {
    data_onshow(){
      return this.$store.state.dataBus.data_popup_show_new_draw
    },
  },
  watch: {},
  methods: {
    close(){
      let v = this
      setTimeout(() => {
        v.$store.commit('setDataBusKey',{
          data_popup_show_new_draw: null,
        })
      },500)
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/style.scss';
  .sp-full-page{
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);

    display: flex;
    align-items: center;
    justify-content: center;

    // @keyframes sp-fade {
    //   0% {
    //     background-color: transparent;
    //   }
    //   100% {
    //     background-color: rgba(0, 0, 0, 0.5);
    //   }
    // }
    // animation: sp-fade 3s 1;
    .bg-anim{
      position: absolute;
      z-index: 0;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: url('/static/img_anim/bg_01_b.gif') center center no-repeat;
      background-size: cover;
      opacity: 0.65;
      background-color: #000;
    }
    .center-pic-box{
      position: relative;
      opacity: 1;
      z-index: 1;
      perspective: 500px;
      .center-pic{
        background-color: #fff;
        border: 5px solid $c;
        margin-top: -50px;
        width: 350px;
        height: 350px;
        border-radius: 10px;
        animation: rock-pic 7s infinite;


        @keyframes rock-pic {
          0% {
            transform: scaleX(1) rotateY(0deg);
          }
          25% {
            transform: scaleX(0.9) rotateY(-20deg) rotateX(5deg) rotateZ(3deg);
          }
          50% {
            transform: scaleX(1) rotateY(0deg) scale(1.1);
          }
          75% {
            transform: scaleX(0.9) rotateY(20deg) rotateX(-2deg) rotateZ(-3deg);
          }
          100% {
            transform: scaleX(1) rotateY(0deg);
          }
        }

        /deep/ .sp-pic{
          width: 100%;
          height: 100%;
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
</style>